// ==============================
// Header All category shop dropdown
// ==============================
function initShopAllCategoryDropdown() {
    const trigger = document.getElementById('shop_all_category');
    const dropdown = document.getElementById('shop_all_category_content');

    if (!trigger || !dropdown) {
        return;
    }

    function positionDropdown() {
        const triggerRect = trigger.getBoundingClientRect();
        const containerRect = dropdown.parentElement.getBoundingClientRect();

        const dropdownWidth = dropdown.offsetWidth;

        let left = triggerRect.left + window.scrollX;
        const containerLeft = containerRect.left + window.scrollX;
        const containerRight = containerRect.right + window.scrollX;

        if (left + dropdownWidth > containerRight) {
            left = containerRight - dropdownWidth;
        }

        if (left < containerLeft) {
            left = containerLeft;
        }

        dropdown.style.top =
            (triggerRect.bottom + 25 + window.scrollY) + 'px';

        dropdown.style.left =
            (left - 20) + 'px';
    }

    function closeDropdown() {
        dropdown.classList.remove('open');

        trigger.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
          // remove overlay and scroll
        document.body.classList.remove('change-bg', 'noscroll');
    }

    function openDropdown() {
        document
            .querySelectorAll('.account_div .dropdown-menu.show')
            .forEach(function(menu) {
                menu.classList.remove('show');
            });

        dropdown.classList.add('open');

        trigger.classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
         // Show overlay and stop scroll
        document.body.classList.add('change-bg', 'noscroll');

        positionDropdown();
    }

    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'true');

    trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (dropdown.classList.contains('open')) {
            closeDropdown();
        } else {
            openDropdown();
        }
    });

    dropdown.addEventListener('mouseover', function(e) {
        const li = e.target.closest('.theme-category-dropdown-parent');

        if (!li || !dropdown.contains(li)) {
            return;
        }

        const targetSelector = li.dataset.target;

        if (!targetSelector) {
            return;
        }

        const targetChild = dropdown.querySelector(targetSelector);

        if (!targetChild) {
            return;
        }

        dropdown
            .querySelectorAll('.theme-category-dropdown-parent')
            .forEach(function(item) {
                item.classList.remove('active');
            });

        dropdown
            .querySelectorAll('.theme-category-main-container > div')
            .forEach(function(item) {
                item.classList.remove('show');
            });

        li.classList.add('active');
        targetChild.classList.add('show');
    });

    document.addEventListener('click', function(e) {
        if (!dropdown.classList.contains('open')) {
            return;
        }

        if (
            e.target.closest('#shop_all_category') ||
            e.target.closest('#shop_all_category_content')
        ) {
            return;
        }

        closeDropdown();
    });

    window.addEventListener('resize', function() {
        if (dropdown.classList.contains('open')) {
            positionDropdown();
        } else {
            closeDropdown();
        }
    });
}

window.addEventListener('load', function() {
    initShopAllCategoryDropdown();
});


// =========================================
// Header All category shop dropdown End
// =========================================


// ==============================
// Start: Central Dropdown Menu Logic
// ==============================
const navItems = document.querySelectorAll(".theme-nav-item:not(.nav-link)");
const dropdownContainer = document.querySelector(".theme-dropdown-container");

if (dropdownContainer) {

function closeDropdown() {

   if( dropdownContainer.classList.contains("open") ){
      dropdownContainer.classList.remove("open");
      navItems.forEach((i) => i.classList.remove("active"));
         // remove overlay and scroll
         document.body.classList.remove('change-bg', 'noscroll');
         document.querySelector("header.header .bottom")?.classList.remove("overplay");
   }

  
}

navItems.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();

    const isSameItemOpen =
      item.classList.contains("active") &&
      dropdownContainer.classList.contains("open");

    if (isSameItemOpen) {
      closeDropdown();
      return;
    }

    // Remove 'active' from all nav items
    closeDropdown();

    // Add 'active' to clicked nav item
    item.classList.add("active");

    // Determine dropdown content
    const parentContent =
      item.querySelector(".theme-mega-menu") ||
      item.querySelector(".theme-dropdown-menu");

    if (!parentContent) return;

    // Clear previous content and insert cloned content
    dropdownContainer.innerHTML = "";
    dropdownContainer.appendChild(parentContent.cloneNode(true));

    // Trigger transition
    dropdownContainer.classList.add("open");
    
    // Show overlay and stop scroll
    document.body.classList.add('change-bg', 'noscroll');
    document.querySelector("header.header .bottom")?.classList.add("overplay");

    // Position dropdown dynamically within container bounds
    const itemRect = item.getBoundingClientRect();
    const containerRect =
      dropdownContainer.parentElement.getBoundingClientRect();
    const dropdownRect = dropdownContainer.getBoundingClientRect();

    let left = itemRect.left + window.scrollX;
    const containerLeft = containerRect.left + window.scrollX;
    const containerRight = containerRect.right + window.scrollX;

    if (left + dropdownRect.width > containerRight)
      left = containerRight - dropdownRect.width;
    if (left < containerLeft) left = containerLeft;

    dropdownContainer.style.top = `${itemRect.bottom + 5 + window.scrollY}px`;
    dropdownContainer.style.left = `${left}px`;
  });
});

// Close dropdown on outside click
document.addEventListener("click", (e) => {
  if (
    !dropdownContainer.contains(e.target) &&
    ![...navItems].some((i) => i.contains(e.target))
  ) {
    closeDropdown();
  }
});

// Close dropdown on window resize
window.addEventListener("resize", closeDropdown);

}

// ==============================
// End: Central Dropdown Menu Logic
// ==============================
